<template>
    <AppHead :title="podcast.title" />

    <div class="hidden md:block z-10 relative">
        <div class="w-full relative">
            <div class="absolute w-full h-40 -top-8 left-0 w-full z-10 h-full bg-center bg-cover scale-125 rounded-lg blur-2xl" :style="'background-image: url(' + podcast.image + ')'" />
        </div>
    </div>

    <section class="pt-6 md:pt-0 px-4 xl:px-0 z-20 relative">
        <div class="bg-gray-300 rounded-2xl md:p-6">
            <div class="flex space-x-4 md:space-x-6 md:pb-6 pb-4">
                <div class="shrink-0 w-[9rem] h-[9rem] md:w-72 md:h-72 bg-center bg-cover rounded-xl" :style="'background-image: url(' + podcast.image + ')'" />
                <div class="flex flex-col justify-between flex-1">
                    <div class="">
                        <div class="text-base font-medium text-regal-blue-700 line-clamp-1">
                            {{ podcast.category?.name }}
                        </div>
                        <div class="font-bold text-xl md:text-3xl tracking-tight mb-0.5 break-word line-clamp-2">
                            {{ podcast.title }}
                        </div>
                        <div class="text-gray-800 eading-none text-sm font-medium mb-4">
                            {{ podcast.episodeCount }}
                        </div>
                        <div class="hidden md:block">
                            <div class="text-sm text-gray-700 font-medium max-w-prose leading-relaxed line-clamp-3">
                                {{ podcast.description }}
                            </div>
                        </div>
                    </div>
                    <div class="w-full flex md:justify-end">
                        <div class="flex shrink-0 space-x-2 h-12">
                            <a :href="'mailto:?subject=' + podcast.title + '&body=' + route('podcasts.show', podcast)" class="flex border border-gray-400 rounded-full h-12 w-12 justify-center items-center text-gray-800 hover:border-gray-700 hover:text-gray-900 cursor-pointer transition-colors duration-100 ease-out active:border-gray-900">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                            </a>
                            <div class="">
                                <div v-if="showTooltip" class="">
                                    <div class="relative w-full flex items-center justify-center">
                                        <div class="flex space-x-1 -translate-y-1/2 mb-2 items-center text-white absolute w-screen max-w-[8rem] bg-regal-blue-900 rounded-md p-3 text-sm font-medium">
                                            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                            <div class="">
                                                Link copied
                                            </div>
                                        </div>
                                        <div class="absolute -bottom-0.5 w-full flex items-center justify-center">
                                            <div class="w-3 h-3 bg-regal-blue-900 rotate-45 rounded-xs">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div @click="copy" class="flex border border-gray-400 rounded-full h-12 px-3 pr-4 space-x-1.5 items-center text-gray-800 hover:border-gray-700 hover:text-gray-900 cursor-pointer transition-colors duration-100 ease-out active:border-gray-900">
                                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                                    <div class="font-medium">
                                        Copy link
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="px-4 mb-6">
        <div class="md:hidden">
            <div class="text-sm text-gray-700 font-medium max-w-prose leading-relaxed line-clamp-3">
                {{ podcast.description }}
            </div>
        </div>
    </section>

    <section class="px-4 xl:px-0 pb-12">
        <SectionHeading title="Episodes" importance="2" />
        <div class="flex flex-col space-y-4 md:space-y-6">
            <EpisodeItem v-for="episode in podcast.episodes" :episode="episode"/>
        </div>
    </section>



</template>

<script>
    import Layout from '@/Shared/Layout'
    import SectionHeading from '@/Shared/SectionHeading'
    import EpisodeItem from '@/Shared/EpisodeItem'
    import { ref } from 'vue'

    export default {
        setup() {
            const showTooltip = ref(false)
            return { showTooltip }
        },
        props: {
            podcast: Object,
        },
        components: { SectionHeading, EpisodeItem },
        layout: Layout,
        methods: {
            async copy() {
                try {
                    await navigator.clipboard.writeText(route('podcasts.show', this.podcast)).then(fn => {
                        this.showTooltip = true
                        setTimeout(() => {this.showTooltip = false}, 1500);
                    });
                } catch(e) {
                    console.log(e);
                }
            }
        },
    }
</script>
